import { ReactNode } from "react";

export const Wrapper = ({ children }: { children: ReactNode }) => (
  <div className="flex justify-center w-full h-full min-h-screen py-10 lg:items-center bg-gray-50">
    {children}
  </div>
);
